/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import FacilityLocation from './facility-location';
import FacilityLocationDetail from './facility-location-detail';
import FacilityLocationUpdate from './facility-location-update';
import FacilityLocationDeleteDialog from './facility-location-delete-dialog';

const FacilityLocationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<FacilityLocation />} />
    <Route path="new" element={<FacilityLocationUpdate />} />
    <Route path=":id">
      <Route index element={<FacilityLocationDetail />} />
      <Route path="edit" element={<FacilityLocationUpdate />} />
      <Route path="delete" element={<FacilityLocationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default FacilityLocationRoutes;
